import { render } from "./VsButton.vue?vue&type=template&id=0ab94542"
import script from "./VsButton.vue?vue&type=script&lang=js"
export * from "./VsButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__